<template>
  <div class="p-16">
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500">Ad Plans</h4>
      </div>

      <BaseAdvancedList searchable :loading="loading" :entities="campaigns" :meta="meta">
        <template #header>
          <CampaignsHeaderLine />
        </template>

        <template #default="listProps">
          <CampaignsLine :campaign="listProps.entity" @edit="setCurrent($event)" />
        </template>
      </BaseAdvancedList>
    </div>

    <portal v-if="campaign" to="app-dialog">
      <CampaignModal :campaign-id="campaign.id" @campaign-modal-close="setCurrent(null)" />
    </portal>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
import CampaignsHeaderLine from '@/components/Campaigns/CampaignsHeaderLine.vue';
import CampaignsLine from '@/components/Campaigns/CampaignsLine.vue';
import CampaignModal from '@/components/Campaigns/CampaignModal.vue';

export default {
  name: 'CampaignList',
  components: {
    CampaignsHeaderLine,
    CampaignsLine,
    CampaignModal,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('ui/campaigns', ['meta', 'included']),
    ...mapGetters('ui/campaigns', ['campaign', 'campaigns']),
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('ui/campaigns', {
      loadCampaigns: 'getCampaigns',
    }),
    ...mapMutations('ui/campaigns', ['setCurrent', 'setIds', 'setMeta', 'setLinks']),

    async init() {
      try {
        await this.fetchData();
      } catch (error) {
        /** handle error */
      }
    },

    async fetchData() {
      const { query } = this.$route;
      this.loading = true;
      try {
        await this.loadCampaigns({
          params: {
            ...query,
            include: [
              'channels',
              'channableData',
              'gaCampaigns.gaAds',
              'gaReportsAggregatedOnCampaignLevel',
              'contactRequestsCount',
              'channelsCount',
              'media',
              'project.media',
            ].join(','),
          },
        });
      } catch (error) {
        //
      }
      this.loading = false;
    },
  },
};
</script>
